module.exports = __webpack_public_path__ + "static/img/pic_idcard_bm.d6d439f4.png";